import { FC } from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
type Option = string | {};
export interface CbOptionSelectItemProps extends ButtonProps {
  onClick: (option: Option) => void;
}
export const CbOptionSelectItem: FC<CbOptionSelectItemProps> = ({
  children,
  onClick,
  ...props
}) => {
  return <Button display="block" borderRadius={0} borderBottom="1px solid" borderColor="cloud.200" colorScheme="transparent" color="text.primary" paddingY={4} paddingLeft={5} paddingRight={12} height="auto" width="100%" onClick={onClick} {...props} data-sentry-element="Button" data-sentry-component="CbOptionSelectItem" data-sentry-source-file="CbOptionSelectItem.tsx">
      {children}
    </Button>;
};